import { render, staticRenderFns } from "./DeliveryZoneMap.vue?vue&type=template&id=22b47a8d&scoped=true"
import script from "./DeliveryZoneMap.vue?vue&type=script&lang=js"
export * from "./DeliveryZoneMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b47a8d",
  null
  
)

export default component.exports